<button type="button" mat-raised-button (click)="fileInput.click()">{{"btn_chooseFile" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
<input hidden (change)="handleFileInput($event.target.files)" (input) = "onInput()" #fileInput type="file" id="file"> 
<br>
<p>{{uploadMessage}}</p>

<h4><b>{{"cptn_RequestDocumentsManual" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</b></h4>

<app-grid-template [columns]="MS_REQDOC_NColumns" [gridData]="MS_REQDOC_N" (action)="gridAction($event)" [groupName]="groupName"></app-grid-template>

<div>
  <button mat-raised-button matStepperPrevious>{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
  <button mat-raised-button matStepperNext>{{"Next" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
</div>